<template>
  <v-row justify="center">
    <v-dialog v-model="dialogVisible" persistent max-width="1000">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="closeDialog()">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Stall Details</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-alert
          outlined
          color="primary"
          class="mx-4 mt-6"
          type="info"
        > 
          These are global settings that apply to all markets
        </v-alert>
        <v-alert
          v-model="alert.show"
          :dismissible="alert.dismissible"
          :type="alert.type"
          transition="fade-transition"
          class="ma-4"
          v-html="alert.text"
        >
        </v-alert>
        <v-form
          ref="form"
          v-model="form"
          class="px-4 pt-2"
        >
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.stall_title"
                filled
                label="Name"
                :rules="[rules.required, rules.maxLength(100, formData.stall_title)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox v-model="formData.is_unavailable" color="primary"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Unavailable indefinitely?</v-list-item-title>
                    <v-list-item-subtitle>Stall cannot be booked for all market dates (won't affect existing bookings)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="formData.required_permission"
                :items="permissionTypes"
                filled
                label="Requires Permission"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="formData.stalls_affected_by_category_rules"
                :items="$store.state.stalls"
                item-text="stall_title"
                item-value="id"
                chips
                label="Stalls that are affected by category rules (eg Neighbouring Stalls)"
                multiple
                class=""
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-select
                v-model="formData.forbidden_categories"
                :items="$store.state.categories"
                item-text="name"
                item-value="id"
                chips
                label="Categories that are not allowed in this stall"
                multiple
                class=""
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="3" class="pt-0">
              <v-text-field
                v-model="formData.price_casual"
                filled
                prefix="$"
                placeholder="0"
                label="Casual Price"
                :rules="[rules.required, rules.currency(formData.price_casual)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="pt-0">
              <v-text-field
                v-model="formData.price_regular"
                filled
                prefix="$"
                placeholder="0"
                label="Regular Price"
                :rules="[rules.required, rules.currency(formData.price_regular)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="pt-0">
               <v-menu
                ref="setupTimeMenu"
                v-model="setupTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="formData.setup_time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formData.setup_time"
                    label="Setup Time"
                    append-icon="mdi-clock-outline"
                    readonly
                    filled
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="setupTimeMenu"
                  v-model="formData.setup_time"
                  full-width
                  @click:minute="$refs.setupTimeMenu.save(formData.setup_time)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="pt-0">
              <v-text-field
                v-model="formData.size"
                filled
                placeholder="3m x 3m"
                label="Size"
                :rules="[rules.maxLength(20, formData.size)]"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Kirribilli doesn't use default stallholders -->
          <!-- <v-autocomplete
            v-model="formData.stallholder"
            :items="$store.state.stallholders"
            filled
            label="Default Stallholder"
            item-text="stall_name"
            item-value="id"
            :filter="stallholderFilter"
            prepend-inner-icon="mdi-account"
            clearable
          >
            <template v-slot:item="{item} ">
              <template>
                  <v-list-item-avatar
                  :color="getStallholderColor(item.stallholder_type)"
                  class="headline font-weight-light white--text"
                  >
                  {{ item.stallholder_type.charAt(0).toUpperCase() }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                  <v-list-item-title v-html="item.stall_name"></v-list-item-title>
                  <v-list-item-subtitle v-html="`${item.first_name} ${item.last_name}`"></v-list-item-subtitle>
                  </v-list-item-content>
              </template>
            </template>
          </v-autocomplete> -->

          <v-text-field
            v-model="formData.notes"
            filled
            label="Public Note"
            hint="eg. there is a tree in the stall"
            :rules="[rules.maxLength(100, formData.notes)]"
          ></v-text-field>

         <v-textarea
            v-model="formData.admin_note"
            filled
            auto-grow
            rows="3"
            counter="200"
            label="Admin Note"
            :rules="[rules.maxLength(200, formData.admin_note)]"
          ></v-textarea>

        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="primary darken-1"
              text
              @click.stop="submitForm()"
              :disabled="isSaveBtnDisabled"
              :loading="isSaveBtnLoading"
          >
              Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="isSaveBtnLoading" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>
<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import { formatDate } from '../js/helpers';

export default {
  data: () => ({
    dialog: '',
    formData : {},
    isSaveBtnLoading: false,
    isCloseBtnDisabled: false,
    isSaveBtnDisabled: false,
    alert: {
      show: false,
      text: '',
      type: 'success',
      dismissible: true,
    },
    form: false,
    rules: {
      password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
        'Password must contain an upper case letter, a numeric character, and a special character',
      required: v => !!v || 'This field is required',
      email: v =>  /.+@.+/.test(v) || 'Please enter a valid email',
      maxLength: (len, v) => (v || '').length <= len || `Invalid character length, maximum ${len}`,
      currency: (v) => /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/.test(v) || 'Please enter a valid currency amount'
    },
    alert: {
      show: false,
      text: '',
      type: 'info',
      dismissible: true,
    },
    setupTimeMenu: false,
    stallholderFilter: (item, queryText, itemText) => {
      let searchString = `${item.stall_name} ${item.first_name} ${item.last_name} ${item.email}`
      return searchString.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  }),
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectedId : {
      required: true,
    },
  },
  watch: {
    dialogVisible(newData, oldData) {
        if(newData) {
          console.log("lilsfddsi")
          console.log(newData, oldData)
          this.formData = Object.assign({}, this.getStallById(this.selectedId));
        }
    },
  },
  methods: {
    closeDialog(){
      this.$emit('close');
      this.formdata = {};
      this.isSaveBtnLoading = false;
      this.resetAlert();
    },
    submitForm(){

      this.resetAlert();
       
      if(this.$refs.form.validate())
        this.updateStall();

    },
    updateStall(){
      this.savingDialog = true;
      let self = this;
      this.isSaveBtnLoading = true;
      
      let isUpdatingId = ''

      if(this.formData.id!==0)
        isUpdatingId=this.formData.id;

      if(!this.formData.stallholder)
        this.formData.stallholder=''; // otherwise its undefined any doesnt get posted


      if(this.formData.market_date_data){ // pass the market date specific data, just so we don't loose it in the response
        this.formData.market_data={};
        this.formData.market_data[this.$store.state.selectedMarketDate] = this.formData.market_date_data;
      }

      axios({
            method: 'POST',
            url: `/wisdom-markets/v1/stalls/${isUpdatingId}`,
            headers: {
               'Authorization': `Bearer ${this.$store.state.accessToken}`,
            }, 
            data: this.formData
        })
        .then(response => {
            console.log("saved", response);
            this.isSaveBtnLoading = false;

            this.savingDialog = false;

            let message = 'Saved!';

            if(response.data.bookings_created && response.data.bookings_created.length > 0) {
                message += `<br /><br /><strong>${response.data.bookings_created.length} New Booking${response.data.bookings_created.length>1 ? 's' : ''} Created: </strong>`

                response.data.bookings_created.forEach((booking, index) => {
                    message += `${formatDate(booking.market_date)}${index === response.data.bookings_created.length - 1 ? "" : ", "}`
                    if(this.$store.state.selectedMarketDate == booking.market_date)
                        this.$emit('createBooking', booking);
                });
            }

            self.showAlert('success', message);

            /* client can't add there own stalls via dashboard so don't worry about this for now */
            // if(response.data.term_id && self.formAction == 'create') {
            //   console.log("adddding", response.data.term_id)
            //   this.$store.commit('addCategory', response.data);
            //   this.categoryFormData.term_id = response.data.term_id;
            //   this.formAction = 'update';
            // }else{
              this.$store.commit('updateStall', response.data);
            //}
        })
        .catch(function (error) {
            console.log("error saving", error);
            //todo display error popup
            // this.isSaveBtnLoading = false;
            // this.isCloseBtnDisabled = false;
            self.savingDialog = false;
            self.showAlert('error', 'Error!');
        });

    },
    showAlert(type, text){
      this.alert.show = true;
      this.alert.text = text
      this.alert.type = type;
    },
    resetAlert() { //and reset
      this.alert = {
        show: false,
        text: '',
        type: 'info',
        dismissible: true,
      }
    },
  },
  computed: {
      //
      isDialogVisible(){
          if(this.dialog != this.dialogVisible) {
              return this.dialogVisible
          }else{
              return this.dialog
          }
      },
      ...mapGetters([
        'getStallById',
        // 'getStallholderColor'
      ]),
      permissionTypes() {
        return this.$store.state.permissionTypes.filter(s => !s.value.includes('_day-') ); // skip the 'day specific' perms (these are applicable for stallholder not stalls)
      }
  },
  mounted() {
      //this.dialog = this.dialogVisible;
     
  }
}
</script>